<template>
  <div class="topping-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <strong>
                <h3>
                  <router-link :to="{ name: 'topping_list'}" class="float-left mr-1 main-link">{{$t('topping.topping')}}</router-link> / {{ (uuid === 'create') ? $t('topping.new') : $t('topping.update')}}
                </h3>
              </strong>
            </div>

            <div class="col-sm-2 col-form-label">
              <span style="margin-right: 15px;">
                {{$t('topping.active')}}
              </span>
              <c-switch style="margin-top: 0" class="active" type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.active" :value="1" :uncheckedValue="0"/>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row class="pb-15">
        <b-col cols="12">
          <b-card class="header mb-0" header-tag="header" footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('topping.basic_information') }}</strong>
              <label class="switch switch-sm switch-text switch-info float-right" @click="updateBasicInformationStatus" v-b-toggle.basic_information_content>
                <i class="fa fa-sort-down" v-if="basicInformationStatus"></i>
                <i class="fa fa-sort-up" v-if="!basicInformationStatus"></i>
              </label>
            </div>
            <b-collapse :visible.sync="basicInformationStatus" id="basic_information_content">
              <b-form class="row">
                <b-col cols="12" class="pt-3" v-if="isClientNz">
                  <b-form-group v-bind:label="$t('topping.topping_type')" :label-cols="2" :horizontal="true">
                    <b-form-select v-model="item.topping_type" v-bind:value="item.topping_type"
                                   :options="topping_types[$session.get('lang')]"
                                   v-bind:placeholder="$t('topping.topping_type')"
                                   :disabled="uuid !== 'create' && uuid !== undefined"
                                   @change="autoGenerateSku()">
                    </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col cols="12" v-if="isClientNz && item.topping_type === 'NORMAL'">
                  <b-form-group v-bind:label="$t('topping.default_sku_l')" :label-cols="2" :horizontal="true" >
                    <b-form-input
                      class="form-control border-radius-4px"
                      v-model="item.sku_default_l"
                      :state="!$v.item.sku_default_l.$invalid"
                      :aria-describedby="'sku-feedback'"
                      :disabled="uuid !== 'create' && uuid !== undefined"
                      @input="autoGenerateSku()"
                    />
                    <b-form-invalid-feedback :id="'sku-feedback'">
                      {{ $t('message.topping_sku_invalid') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col cols="12" v-if="isClientNz && item.topping_type === 'NORMAL'">
                  <b-form-group v-bind:label="$t('topping.default_sku_xl')" :label-cols="2" :horizontal="true" >
                  <b-form-input
                    class="form-control border-radius-4px"
                    v-model="item.sku_default_xl"
                    :state="!$v.item.sku_default_xl.$invalid"
                    :aria-describedby="'sku-feedback'"
                    :disabled="uuid !== 'create' && uuid !== undefined"
                    @input="autoGenerateSku()"
                  />
                  <b-form-invalid-feedback :id="'sku-feedback'">
                    {{ $t('message.topping_sku_invalid') }}
                  </b-form-invalid-feedback>
                </b-form-group>
                </b-col>
                <b-col cols="12" v-if="isClientNz && item.topping_type === 'NORMAL'">
                  <b-form-group v-bind:label="$t('topping.extra_sku_l')" :label-cols="2" :horizontal="true" >
                    <b-form-input
                      class="form-control border-radius-4px"
                      v-model="item.sku_extra_l"
                      :state="!$v.item.sku_extra_l.$invalid"
                      :aria-describedby="'sku-feedback'"
                      :disabled="uuid !== 'create' && uuid !== undefined"
                      @input="autoGenerateSku()"
                    />
                    <b-form-invalid-feedback :id="'sku-feedback'">
                      {{ $t('message.topping_sku_invalid') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col cols="12" v-if="isClientNz && item.topping_type === 'NORMAL'">
                  <b-form-group v-bind:label="$t('topping.extra_sku_xl')" :label-cols="2" :horizontal="true" >
                    <b-form-input
                      class="form-control border-radius-4px"
                      v-model="item.sku_extra_xl"
                      :state="!$v.item.sku_extra_xl.$invalid"
                      :aria-describedby="'sku-feedback'"
                      :disabled="uuid !== 'create' && uuid !== undefined"
                      @input="autoGenerateSku()"
                    />
                    <b-form-invalid-feedback :id="'sku-feedback'">
                      {{ $t('message.topping_sku_invalid') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <b-col cols="12" v-if="!isClientNz || (isClientNz && item.topping_type !== 'NORMAL')">
                  <b-form-group v-bind:label="$t('topping.sku')" :label-cols="2" :horizontal="true" >
                    <b-form-input
                      class="form-control border-radius-4px"
                      v-model="item.sku"
                      :state="!$v.item.sku.$invalid"
                      :aria-describedby="'sku-feedback'"
                      :disabled="(uuid !== 'create' && uuid !== undefined) || (isClientNz && item.topping_type !== 'NORMAL')"
                      @input="autoGenerateSku()"
                    />
                    <b-form-invalid-feedback :id="'sku-feedback'">
                      {{ $t('message.required_filed') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group v-bind:label="$t('topping.aggregator_code')" :label-cols="2" :horizontal="true">
                    <b-form-input
                      type="text"
                      class="form-control border-radius-4px"
                      v-model="item.aggregator_code"/>
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <div class="form-group row" >
                    <legend class="col-sm-2 col-form-label">{{$t('topping.name')}}</legend>
                    <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id">
                      <b-form-input type="text"
                                    :name="`name[${lang}]`"
                                    class="form-control border-radius-4px"
                                    v-model="item.name[lang]"
                                    v-bind:placeholder="$t('common.text_' + lang)"
                      />
                    </div>
                  </div>
                </b-col>
                <b-col cols="12" class="pt-3 hide">
                  <b-form-group v-bind:label="$t('topping.name_seo')" :label-cols="2" :horizontal="true" >
                    <b-form-input
                      type="text"
                      class="form-control border-radius-4px col-sm-5"
                      v-model="item.name_seo">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="12" class="pt-3">
                  <b-form-group v-bind:label="$t('topping.short_name')" :label-cols="2" :horizontal="true" >
                    <b-form-input
                      type="text"
                      class="form-control border-radius-4px col-sm-5"
                      v-model="item.short_name">
                    </b-form-input>
                  </b-form-group>
                </b-col>

                <b-col cols="12" class="row m-0 p-0">
                  <div class="col-sm-6 row m-0 p-0 pt-3 mb-3" v-for="(urlValue, keyName, index) in imageData" :key="`${keyName}-${imageDataKey}`">
                    <legend class="col-sm-4 col-form-label" :class="{'text-right': (index % 2)}">
                      {{$t('topping.'+keyName)}}
                      <b-tooltip :target="'image-' + keyName" placement="top">
                        <div class="text-left" v-html="getImageHelpInfo('topping', keyName)"></div>
                      </b-tooltip>
                    </legend>
                    <div class="col-sm-8 img-min-height">
                      <b-form-file :id="keyName" @change="previewImage" accept="image/*"
                                   :placeholder="$t('message.choose_a_file')"></b-form-file>
                       <ImagePreview :url="urlValue" :keyUrl="keyName" @onDeleteImage="handleDeleteImage" />            
                    </div>
                  </div>
                </b-col>

                <b-col cols="12" class="pt-3">
                  <b-form-group v-bind:label="$t('topping.type')" :label-cols="2" :horizontal="true">
                    <b-form-select v-model="item.type" v-bind:value="item.type"
                                   :options="type_statuses[$session.get('lang')]"
                                   v-bind:placeholder="$t('topping.type')">
                    </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col cols="12" class="pt-3">
                  <b-form-group v-bind:label="$t('topping.special')" :label-cols="2" :horizontal="true">
                    <b-form-select v-model="item.special" v-bind:value="item.special"
                                   :options="type_specials[$session.get('lang')]"
                                   v-bind:placeholder="$t('topping.special')">
                    </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col cols="12" class="pt-3">
                  <b-form-group v-bind:label="$t('topping.only_lunch')" :label-cols="2" :horizontal="true">
                    <c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.only_lunch" :value="1" :uncheckedValue="0"/>
                  </b-form-group>
                </b-col>
                <b-col cols="12" class="pt-3">
                  <b-form-group v-bind:label="$t('topping.sequence')" :label-cols="2" :horizontal="true" >
                    <b-form-input
                      type="number"
                      class="form-control border-radius-4px col-sm-5"
                      v-model="item.sequence">
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-form>
            </b-collapse>
            <div slot="footer">
              <div class="back-button">
                <button type="button" class="btn border-radius-4px bg-main float-left" @click="$router.push({name: 'topping', query: {rollback: 1}})"><i class="fa fa-arrow-left"></i> {{$t('common.back')}}</button>
              </div>
              <div class="btn-save">
                <button type="button" class="btn bg-main border-radius-4px pl-3 pr-3" v-on:click="publishTopping()" :disabled="checkSubmit() "> {{$t('common.publish')}}</button>
                <button type="button" class="btn bg-main border-radius-4px pl-3 pr-3" v-on:click="saveTopping()" :disabled="checkSubmit() "> {{$t('common.save')}}</button>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="pb-15">
        <b-col cols="12">
          <b-card class="header mb-0" header-tag="header" footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('topping.price') }}</strong>
              <label class="switch switch-sm switch-text switch-info float-right" @click="updatepriceStatus" v-b-toggle.price_content>
                <i class="fa fa-sort-down" v-if="priceStatus"></i>
                <i class="fa fa-sort-up" v-if="!priceStatus"></i>
              </label>
            </div>
            <b-collapse :visible.sync="priceStatus" id="price_content">
              <b-form class="row" v-if="single.config.topping_tax_price">
                <b-col cols="6">
                  <b-form-group v-bind:label="$t('topping.tax_rate')" :label-cols="4" :horizontal="true">
                    <input type="number" class="form-control" v-model="item.price.tax_rate"/>
                  </b-form-group>
                </b-col>
              </b-form>
              <b-form class="row">
                <div class="col-sm-6" v-for="(tier, index) in item.price.price" :key="index">
                  <b-card class="pb-0" v-bind:title="Object.values(item.price.price).length > 1 ? tier.name ? tier.name : $t('topping.tier') + ' '+ tier.key : ''">
                    <template v-if="tier.sizes.length > 0">
                      <b-form-group  v-for="(size, p) in tier.sizes" :key="p" v-bind:label="size.name[$session.get('lang')]">
                        <b-row>
                          <div :class="single.config.topping_tax_price ? 'col-sm-6' : 'col-sm-12'">
                            <b-form-group v-bind:label="$t('topping.price')" :label-cols="6" :horizontal="true">
                              <b-form-input
                                type="number"
                                class="form-control border-radius-4px"
                                v-model="size.price"
                                step="0.25"
                                onkeypress="return event.charCode >= 48 || event.charCode == 46 "
                                :aria-describedby="'price-error-' + index + '-' + p"
                                :state="syncState(index, p)"
                                @input="updateSize()"
                                min="0"
                                >
                              </b-form-input>
                              <b-form-invalid-feedback
                                :id="'price-error-' + index + '-' + p">
                                {{ $t('message.required_filed') }}
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </div>

                          <div class="col-sm-6" v-if="single.config.topping_tax_price">
                            <b-form-group v-bind:label="$t('topping.price_without_tax')" :label-cols="6" :horizontal="true">
                              <b-form-input
                                type="number"
                                class="form-control border-radius-4px"
                                v-model="item.price.price_without_tax[index].sizes[p].price">
                              </b-form-input>
                            </b-form-group>
                          </div>
                        </b-row>
                      </b-form-group>
                    </template>
                    
                  </b-card>
                </div>
              </b-form>
            </b-collapse>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="pb-15" v-if="single.config.topping_layer_mapping">
        <b-col cols="12">
          <b-card class="header mb-0" header-tag="header" footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('topping.layer_mapping') }}</strong>
              <label class="switch switch-sm switch-text switch-info float-right" @click="updateLayerMappingStatus" v-b-toggle.topping_layer_mapping_content>
                <i class="fa fa-sort-down" v-if="layerMappingStatus"></i>
                <i class="fa fa-sort-up" v-if="!layerMappingStatus"></i>
              </label>
            </div>
            <b-collapse :visible.sync="layerMappingStatus" id="topping_layer_mapping_content">
              <b-row class="pb-15">
                <b-col cols="12">
                  <div class="pull-right mr-4">
                    <button type="button" class="btn bg-main right" @click="addNewToppingLayerMapping"><i class="fa fa-plus"></i>&nbsp; {{$t('common.new')}}</button>
                  </div>
                </b-col>
              </b-row>
              <b-row cols="12" class="option-box" v-for="(layer,i) in item.topping_layer_mapping" :key="layer.id">
              <b-col cols="2" class="d-flex adjustment-padding-5">
                  <div class="layer-label">{{$t('topping_layer_mapping.size')}}</div>
                  <div class="layer-code-input">
                    <b-form-select v-model="layer.first_layer_id" :options="firstLayerOptions"></b-form-select>
                  </div>
                </b-col>
                <b-col cols="2" class="d-flex adjustment-padding-5">
                  <div class="layer-label">{{$t('topping_layer_mapping.crust')}}</div>
                  <div class="layer-code-input">
                    <b-form-select v-model="layer.second_layer_id" :options="secondLayerOptions"></b-form-select>
                  </div>
                </b-col>
                <b-col cols="7" class="d-flex adjustment-padding-5">
                  <div class="layer-label">{{$t('topping_layer_mapping.sku')}}</div>
                  <div class="layer-code-input">
                    <b-form-textarea
                            class="form-control border-radius-4px col-sm-10"
                            v-model="layer.sku">
                    </b-form-textarea>
                  </div>
                </b-col>
                <b-col cols="1" class="d-flex adjustment-padding-5 height-40">
                  <b-button variant="danger" v-on:click="removeLayerMapping(i)"><i class="fa fa-trash-o"></i></b-button>
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import { required, requiredIf, maxLength } from 'vuelidate/lib/validators'
  import cSwitch from '../../../components/Switch'
  import ImagePreview from '@/components/Partials/ImagePreview'

  let vm = null
  export default {
    name: 'ToppingForm',
    props: {
      uuid: {
        type: String,
        required: true,
        default: 'create'
      }
    },
    components: {
      cSwitch,
      ImagePreview
    },
    data: function () {
      return {
        item: {
          uuid: '',
          sku: '',
          sku_default_l: '',
          sku_default_xl: '',
          sku_extra_l: '',
          sku_extra_xl: '',
          name: {},
          name_seo: '',
          image: {},
          prices: {},
          price: {
            price: {}
          },
          active: 1,
          sequence: 0,
          short_name: '',
          type: 0,
          special: 0,
          only_lunch: 0,
          aggregator_code: '',
          topping_layer_mapping : [],
          topping_type: 'NORMAL'
        },
        tier: this.$store.getters.config.main.tiers,
        single: this.$store.getters.config.gms.menu,
        basicInformationStatus: true,
        priceStatus:true,
        imageData: {},
        imageDataKey: 0,
        images: ['desktop_thumbnail', 'desktop_detail', 'mobile_thumbnail', 'mobile_detail'],
        type_statuses: [],
        type_specials: [],
        topping_types: [],
        firstLayerData:{},
        firstLayer:{},
        lang:this.$session.get('lang'),
        topping_price: false,
        single: this.$store.getters.config.gms.menu,
        layerMappingStatus : true,
        firstLayerOptions: [
          {value: null, text: 'All'}
        ],
        secondLayerOptions: [
          {value: null, text: 'All'}
        ],
        isClientNz: false
      }
    },
    mixins: [
      validationMixin
    ],
    validations: {
      item: {
        sku: {
          requiredIf: requiredIf(function () {
            return !this.isClientNz;
          })
        },
        sku_default_l: {
          maxLength: maxLength(15),
          
        },
        sku_default_xl: {
          maxLength: maxLength(15)
        },
        sku_extra_l: {
          maxLength: maxLength(15)
        },
        sku_extra_xl: {
          maxLength: maxLength(15)
        },
        name: {
          required
        },
        price: {
          price: {
            $each: {
              sizes: {
                $each: {
                  price: {
                    required
                  }
                }
              }
            }
          }
        }
      }
    },
    computed: {},
    methods: {
      handleDeleteImage(imageKey) {
        vm.imageData[`${imageKey}`] = ''
        vm.item.image[`${imageKey}`] = ''
        vm.imageDataKey += 1
      },
      checkSubmit: function () {
        let validateName = false
        let form = this.validateForm()
        return form || validateName
      },
      validateForm() {
        const toppingPrices = Object.values(this.item.price.price).every(tier => {
          return tier.sizes.every(size => {
            if (size.price === 0) return true;
            return !!size.price;
          })
        });
        const name = Object.values(this.item.name).every(name => !!name)
        return !(toppingPrices && this.item.sku && name);
      },
      updateSize() {  
        vm.$forceUpdate();
      },
      syncState(tierIndex, sizeIndex) {
        const valid = this.$v.item.price.price.$each[tierIndex].sizes.$each[sizeIndex].$model.price;
        if (valid === 0) return true;
        return !!valid;
      },
      saveTopping () {
        let data = JSON.parse(JSON.stringify(vm.item))
        
        let formData = new FormData()
        let oldUrl = []
        for (let i in vm.item.image) {
          if (vm.item.image[i] && vm.item.image[i].type != undefined) {
            formData.append(i, vm.item.image[i])
          } else {
            oldUrl[i] = vm.item.image[i]
          }
        }
        let config = {headers: {'Content-Type': 'multipart/form-data'}}
        vm.axios.menu.uploadImageTopping(formData, config, function (response) {
          data.image = {}
          for (let i in response.data.data.item) {
            data.image[i] = response.data.data.item[i]
          }
          for (let i in oldUrl) {
            data.image[i] = oldUrl[i]
          }
          if (Object.getOwnPropertyNames(data.image).length > 0) {
            for (let i in vm.imageData) {
              vm.imageData[i] = data.image[i] != null ? data.image[i] : ""
            }
          }
          data.name_seo = data.name_seo ? data.name_seo : data.short_name
          if (vm.item.uuid === '' || vm.item.uuid === 'create') {
            vm.axios.menu.createTopping(data, function (response) {
              vm.$toastr.success(vm.$t('message.save_successful'), vm.$t('message.success'), {})
              vm.$router.push({name: 'topping_list'})
            }, function () {
            })
          } else {
            vm.axios.menu.updateTopping(data, function (response) {
              vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
              vm.$router.push({name: 'topping_list'})
            }, function () {
            })
          }
        })
      },
      /**
       * get list categories for select box
       */
      getDetailTopping () {
        vm.axios.menu.getDetailTopping(vm.uuid, function (response) {
          let item = response.data.data.item
          
          if (vm.isClientNz) {
            item = vm.extractSku(item)
          }
          
          if (item.name == null) {
            item.name = {'ja': '', 'en': ''}
          }
          if (!item.prices) {
            item.prices = {}
          }

          let data = {}
          for (let i in vm.images) {
            if (!vm.images.hasOwnProperty(i)) continue
            data[vm.images[i]] = vm.item.image[vm.images[i]] != null ? vm.item.image[vm.images[i]] : ''
          }
          if(Object.getOwnPropertyNames(data).length > 0) {
            vm.imageData = data
          }

          for (let i in item.price.price) {
            let price_length = Object.keys(item.price.price[i]).length
            if (!item.price || price_length <= 0) {
              vm.item.active = item.active
              vm.item.aggregator_code = item.aggregator_code
              vm.item.id = item.id
              vm.item.image = item.image
              vm.item.name = item.name
              vm.item.name_seo = item.name_seo
              vm.item.only_lunch = item.only_lunch
              vm.item.prices = item.prices
              vm.item.short_name = item.short_name
              vm.item.sku = item.sku
              vm.item.special = item.special
              vm.item.topping_prices = item.topping_prices
              vm.item.type = item.type
              vm.item.uuid = item.uuid
              vm.item.sequence = item.sequence
              vm.item.topping_layer_mapping = item.topping_layer_mapping
            } else {
              vm.item = item
            }
            if (item.price && price_length > 0) {
              let price_update = vm.item.price.price
              let price_update_without_tax = vm.item.price.price_without_tax != null ? vm.item.price.price_without_tax : price_update
              vm.item.price.tax_rate = vm.item.price.tax_rate != null ? vm.item.price.tax_rate : 0
              vm.item.price.price = {}
              vm.item.price.price_without_tax = {}

              Object.keys(price_update).forEach((key_tier) => {
                const content = price_update[key_tier] || {};
                console.log({content});
                const data = {}
                data.sizes = []
                data.key = key_tier;
                data.name = vm.tier ? vm.tier[key_tier] : {};
                vm.firstLayer.map((item) => {
                  const info = vm._.cloneDeep(item);
                  const price = content[item.sku];
                  info.price = price || 0;
                  data.sizes.push(info)
                })
                vm.item.price.price[key_tier] = data
              })
               Object.keys(price_update_without_tax).forEach((key_tier) => {
                const content = price_update_without_tax[key_tier] || {};
                const data = {}
                data.sizes = []
                data.key = key_tier;
                data.name = vm.tier ? vm.tier[key_tier] : {};
                vm.firstLayer.map((item) => {
                  const info = vm._.cloneDeep(item);
                  const price = content[item.sku];
                  info.price = price || 0;
                  data.sizes.push(info)
                })
                vm.item.price.price_without_tax[key_tier] = data;
              })
              vm.$forceUpdate('item.price.price')
              vm.$forceUpdate('item.price.price_without_tax')
            } else {
              vm.createTopping()
            }
            break;
          }
        })
      },
      /**
       * update status of customise session
       */
      updateBasicInformationStatus () {
        this.basicInformationStatus = !this.basicInformationStatus
      },
      updatepriceStatus () {
        this.priceStatus = !this.priceStatus
      },
      updateLayerMappingStatus () {
        this.layerMappingStatus = !this.layerMappingStatus
      },
      addNewToppingLayerMapping () {
        vm.item.topping_layer_mapping.push({
          first_layer_id: null,
          second_layer_id: null,
          sku: '',
          topping_id: vm.item.id
        })
      },
      removeLayerMapping (index) {
        let topping_layer_mapping = []
        for (let i in vm.item.topping_layer_mapping) {
          if (i != index) {
            topping_layer_mapping.push(vm.item.topping_layer_mapping[i])
          }
        }
        vm.item.topping_layer_mapping = topping_layer_mapping
      },
      /**
       * preview image after select
       * @param event
       */
      previewImage (event) {
        let input = event.target
        if (input.files && input.files[0]) {
          let reader = new FileReader()
          reader.onload = (e) => {
            this.imageData[input.id] = e.target.result
          }
          // this.imageData = []
          let data = {}
          for (let i in this.images) {
            data[this.images[i]] = this.imageData[this.images[i]]
          }
          this.imageData = data
          reader.readAsDataURL(input.files[0])
          this.item.image = this.item.image ? this.item.image : {}
          this.item.image[input.id] = input.files[0]
        }
      },
      /**
       * get list categories for select box
       */
      getStatusData () {
        let langs = Object.keys(vm.$i18n.messages)
        for (let l in langs) {
          vm.type_statuses[langs[l]] = [
            {text: vm.$t('topping.type_all', langs[l]), value: 0},
            {text: vm.$t('topping.type_default', langs[l]), value: 1},
            {text: vm.$t('topping.type_extra', langs[l]), value: 2}
          ]
          vm.type_specials[langs[l]] = [
            {text: vm.$t('topping.type_specials_0', langs[l]), value: 0},
            {text: vm.$t('topping.type_specials_1', langs[l]), value: 1},
            {text: vm.$t('topping.type_specials_2', langs[l]), value: 2},
            {text: vm.$t('topping.type_specials_3', langs[l]), value: 3}
          ]
          vm.topping_types[langs[l]] = [
            {text: vm.$t('topping.topping_type_normal', langs[l]), value: "NORMAL"},
            {text: vm.$t('topping.topping_type_default', langs[l]), value: "DEFAULT"},
            {text: vm.$t('topping.topping_type_nosauce', langs[l]), value: "NOSAUCE"},
            {text: vm.$t('topping.topping_type_nocheese', langs[l]), value: "NOCHEESE"}
          ]
        }
      },
      getFirstLayer () {
        vm.axios.menu.getFirstLayer(function (response) {
          vm.firstLayer = response.data.data.items
          response.data.data.items.forEach(first => {
            vm.firstLayerOptions.push({
              value: first.id,
              text: first.sku
            })
          })
          vm.axios.menu.getSecondLayer(function (response) {
            response.data.data.items.forEach(second => {
              vm.secondLayerOptions.push({
                value: second.id,
                text: second.sku
              })
            })

            if (vm.uuid !== 'create' && vm.uuid !== undefined) {
              vm.getDetailTopping()
            } else {
              vm.createTopping()
            }
          })
          //
        })
      },
      createTopping () {
        vm.firstLayerData.tier = {}
        vm.firstLayer = vm.firstLayer.map((item) => {
          item.price = null
          return item
        })
        vm.item.price = {}
        vm.item.price.active = 1
        vm.item.price.from = "1900-01-01 00:00:01"
        vm.item.price.to = "9999-12-31 23:59:59"
        vm.item.price.price = {}
        vm.item.price.price_without_tax = {}
        vm.item.price.tax_rate = 0
        Object.keys(vm.tier).map((item) => {
          let data = {}
          data.name = vm.tier[item]
          data.key = item
          data.sizes = vm.firstLayer
          vm.item.price.price[item] = data
          vm.item.price.price_without_tax[item] = data
        })
        vm.$forceUpdate('item.price.price')
      },
      publishTopping () {
        vm.axios.menu.publishTopping({
          'scope': 'partial',
          'bulk': [vm.item.id]
        }, function (response) {
          vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
        })
      },
      concatSku (default_sku_l, default_sku_xl, extra_sku_l, extra_sku_xl) {
        if(default_sku_l.trim() === "") {
          default_sku_l = "na"
        }
        if(default_sku_xl.trim() === "") {
          default_sku_xl = "na"
        }
        if(extra_sku_l.trim() === "") {
          extra_sku_l = "na"
        }
        if(extra_sku_xl.trim() === "") {
          extra_sku_xl = "na"
        }

        return `L|${default_sku_l}*XL|${default_sku_xl}-L|${extra_sku_l}*XL|${extra_sku_xl}`;
      },
      extractSku(item) {
        if(["DEFAULT", "NOSAUCE", "NOCHEESE"].indexOf(item.sku) !== -1) {
          item.topping_type = item.sku
          return item;
        }
        item.topping_type = "NORMAL"
        let skus = item.sku.split("-")
        if(skus.length === 2) {
          let defaultSkusPath = skus[0].split("*")
          if(defaultSkusPath.length === 2) {
            let defaultSkuL = defaultSkusPath[0].split("|")
            if(typeof defaultSkuL[1] !== "undefined") {
              item.sku_default_l = defaultSkuL[1] === 'na' ? "" : defaultSkuL[1]
            }
            let defaultSkuXL = defaultSkusPath[1].split("|")
            if(typeof defaultSkuXL[1] !== "undefined") {
              item.sku_default_xl = defaultSkuXL[1] === 'na' ? "" : defaultSkuXL[1]
            }
          }
          let extraSkusPath = skus[1].split("*")
          if(extraSkusPath.length === 2) {
            let extraSkuL = extraSkusPath[0].split("|")
            if(typeof extraSkuL[1] !== "undefined") {
              item.sku_extra_l = extraSkuL[1] === 'na' ? "" : extraSkuL[1]
            }
            let extraSkuXL = extraSkusPath[1].split("|")
            if(typeof extraSkuXL[1] !== "undefined") {
              item.sku_extra_xl = extraSkuXL[1] === 'na' ? "" : extraSkuXL[1]
            }
          }
        }
        return item
      },
      autoGenerateSku() {
        if (!vm.isClientNz) return;
        if (vm.item.topping_type === "NORMAL") {
          vm.item.sku_default_l = this.validSku(vm.item.sku_default_l)
          vm.item.sku_default_xl = this.validSku(vm.item.sku_default_xl)
          vm.item.sku_extra_l = this.validSku(vm.item.sku_extra_l)
          vm.item.sku_extra_xl = this.validSku(vm.item.sku_extra_xl)
          vm.item.sku = this.concatSku(vm.item.sku_default_l, vm.item.sku_default_xl, vm.item.sku_extra_l, vm.item.sku_extra_xl)
        } else {
          vm.item.sku = vm.item.topping_type
        }
      },
      validSku(sku) {
        let newSku = sku.trim().replace(/[^a-zA-Z0-9]/g, '').toUpperCase()
        if (newSku.length > 15) {
          newSku = sku.substring(0, 15)
        }
        return newSku;
      }
    },
    created: function () {
      vm = this
      vm.isClientNz = this.client_uuid.nz === localStorage.getItem('clientID')
      this.autoGenerateSku()
    },
    updated: function () {
    },
    mounted: function () {
      vm.getStatusData ();
      let data = {}
      for (let i in vm.images) {
        if(!vm.images.hasOwnProperty(i)) continue;
        data[vm.images[i]] = ''
      }
      vm.imageData = data
      if (vm.uuid !== 'create' && vm.uuid !== undefined) {
        vm.getDetailTopping()
      }
      vm.getFirstLayer()
    }
  }
</script>

<style scoped>

  .img-min-height {
    height: 200px;
  }

  .back-button {
    padding-left: 25px;
    width: 95px;
    float: left;
  }
  .topping-form .switch.switch-icon{
    margin-top: 5px;
  }
  .topping-form .header-custom-switch{
    margin-top: 5px;
    margin-bottom: 0;
  }
  .topping-form .header-custom-switch .col-form-label{
    text-align: right;
  }
  .topping-form .header-custom-switch .uppercase{
    display: inline-flex;
  }
  .topping-form .btn-save{
    float: right !important;
    padding-right: 22px;
    margin-right: 0px !important;
    box-sizing: border-box;
    text-align: right;
  }
  /*END Form Wizard*/
  .option-box {
    padding-bottom: 15px;
  }

  .option-layer {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    background: #e1e6eb;
    padding: 20px;
  }

  .layer-label {
    width: auto;
    padding-right: 10px;
    height: 35px;
    line-height: 35px;
    font-weight: 600;
  }

  .layer-code-input {
    flex: 1;
    padding-left: 5px;
    padding-right: 5px;
  }
  .height-40 {
    height: 40px;
  }
</style>

<style>
  .preview-image {
    width: 100%;
  }
  .topping-form .card-footer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }
  .topping-form div.header,
  .topping-form .header .card-header{
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }
  .close-btn .fa-angle-right {
    margin-right: -4px;
  }
  .close-btn .fa-angle-left {
    margin-left: -4px;
  }
  .topping-form .btn-primary .fa{
    font-size: 20px;
  }
  .topping-form .btn-primary {
    color: #0091ff;
    background-color: transparent;
  }
  .topping-form .btn-primary:hover{
    color: #0091ff;
    background-color: transparent;
  }
  .pt-05{
    padding: 0.5rem;
  }
  .pb-15{
    padding-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/topping/BaseForm.vue